import { render } from "./InboxPage.vue?vue&type=template&id=1ff204c6&ts=true"
import script from "./InboxPage.vue?vue&type=script&lang=ts"
export * from "./InboxPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__